// tslint:disable-next-line:max-line-length
export const HERO_ALT_TEXT = `Female delivery driver delivering food and earning money`
